
import { defineComponent, reactive, onMounted, computed, ref, watch, onBeforeUnmount, toRaw, onUnmounted } from "vue";
import { ethitransService } from "@/services/EthitransService";
import { common } from "@/common/services/Common";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
import moment from "moment";
import cloneDeep from 'lodash/cloneDeep';
import SuccessfulModalCustom from "@/components/modal/SuccessfulModalCustom.vue";
import CreateLineItemInJobEstimation from "../todo/CreateLineItemInJobEstimation.vue";
import VoiceToText from "@/components/VoiceToText.vue";
import { useI18n } from 'vue-i18n';



import { config } from "@/Config";
import { useUnsavedChanges } from "../composables/useUnsavedChanges";
import CurrencyInput from "./components/CurrencyInput.vue";
import CustomModal from '@/components/ui/customModal/index.vue';
import CustomLoader from '@/components/ui/loader/index.vue'

export default defineComponent({
    name: "ProjectWorkflowCreateJobEstimation",
    props: {
        editId: String,
    },
    components: {
        SuccessfulModalCustom,
        CreateLineItemInJobEstimation,
        VoiceToText,
        CurrencyInput,
        CustomModal,
        CustomLoader
        // useUnsavedChanges
    },
    setup(props, { emit, expose }) {
        const { t } = useI18n();
        const router = useRouter();
        const table = ref(); //reference to your table element
        const tabulator = ref(); //variable to hold your table
        const filterValue = ref();
        const defMarkUpType = ref();
        const isEditMode = ref(false);
        const {
            params: { projectId },
        } = useRoute();
        const isInvalid = ref(false);
        const showItemModal = ref(false);
        const itemSearchedvalue = ref('');
        const deletedItemsIds = ref<any>([]);
        const currenylySelectedState = reactive({
            index:null as any,
            value:null as any
        });

        const state = reactive({
            tableData: [] as any,
            selectedRows: [] as any,
            projectId: projectId,
            estimationUUId: '' as any,
            selectUnitId: '' as any,
            selectSubItemIndex: '' as any,
            selectItemIndex: '' as any,
            selectSubItem: '' as any,
            selectDeleteItem: '' as any,
            selectIndex: '' as any,
            selectItemId: '' as any,
            dataFor: '' as any,
            cloningSelectedItem: false,
            selectItems: [
                {
                    'id': 0,
                    'markup_type': defMarkUpType,
                    'cost': 0,
                    'markup': 0,
                    'quantity': '',
                    'tableSelected': false,
                    'isAllowance': false,
                    'isEditing': true
                }
            ] as any,
            data: {
                inputFrom: 'markUp',
                createDate: moment(new Date()).format("Y-MM-DD"),
                minDate: '',
                searchName: '' as any,
                lineItems: [] as any,
                unitLists: [] as any,
                title: '' as any,
                unit: {
                    name: '',
                    abbreviation: '',
                },
                showSuccesCustomModal: false,
                showDeleteItem: false,
                successFulMessage: '',
            },
            ui: {
                isLoading: {
                    isEdit: false,
                    getItemList: false,
                    isUnitEdit: false,
                    getUnit: false,
                    addNewSubItem: false,
                    isSaveSend: false,
                    getData: false,
                },
                isPostLoading: {
                    delete: false,
                    addUnite: false,
                    selectedButton: false,
                    createJobEstimation: false,
                },
                errors: {
                    errorList: {
                        createUnit: [] as any,
                        createJobEstimation: [] as any,
                    },
                    validationErrorList: {
                        itemName: "",
                        unitName: "",
                        unitAbbreviation: "",
                    },
                    hasError: false,
                    titleError: false
                },
            },
        });
        const originalState = ref(cloneDeep(toRaw(state.selectItems)));
        // const hasUnsavedChanges = ref(false);
        const { hasUnsavedChanges, markAsDirty, markAsSaved } = useUnsavedChanges(() => cloneDeep(toRaw(state.selectItems)));

        watch(
            () => state.selectItems,
            (newVal) => {
                // hasUnsavedChanges.value = true;
                markAsDirty();
            },
            { deep: true }
        );
        expose({
            hasUnsavedChanges
        });


        // const updateAllowance = () => {
        //     state.selectItems.forEach((item: any) => {
        //         if (item.isAllowance) {
        //             item.allowance = item.subTotal;
        //         }
        //     });
        // };

        // // Watch for changes in the isChecked property for all items
        // watch(
        //     state.selectItems,
        //     () => {
        //         updateAllowance();
        //     },
        //     { deep: true } // This ensures the watcher reacts to nested object changes
        // );

        const handleBeforeUnload = (event: any) => {
            if (hasUnsavedChanges.value) {
                event.preventDefault();
                event.returnValue = ''; // for most browsers
                return ''; // for older browsers
            }
        };



        function gotoJobEstimationSend() {
            // router.push({
            //     name: "send-job-estimation",
            //     params: { estimationId: state.estimationUUId },
            // });
            emit('send-job-estimation', state.estimationUUId);
        }

        function gotoJobEstimation() {
            // router.push({
            //     name: "list-job-estimation",
            //     params: { projectId: projectId },
            // });
            emit('back-to-job-estimation-list');
        }

        function deleteItemShow(item: any) {
            state.selectDeleteItem = item;
            state.data.showDeleteItem = !state.data.showDeleteItem;
            // $("#deleteItem").modal("show");
        }
        function deleteItemClose() {
            state.selectDeleteItem = '';
            state.data.showDeleteItem = !state.data.showDeleteItem;
        }

        function closeSuccessCustomModal() {
            // $("#SuccessfulModalCustom").modal("hide");
            // console.log("CHECK TEH ITEM>>>> ", state.ui.isLoading.isSaveSend)
            if (state.ui.isLoading.isSaveSend) {
                gotoJobEstimationSend()
            } else {
                gotoJobEstimation();
            }
        }

        function validationCreateJobEstimation() {
            state.ui.errors.titleError = false;
            state.ui.errors.hasError = false;
            if (!state.data.title) {
                state.ui.errors.titleError = true;
                state.ui.errors.hasError = true;

            }
            state.selectItems.forEach((item: any) => {
                item.quantityError = false
                if (!item.quantity) {
                    item.quantityError = true
                    item.isEditing= true
                    state.ui.errors.hasError = true;
                }
            });

            state.selectItems.forEach((item: any) => {
                item.unitError = false
                if (!item.unit) {
                    item.unitError = true
                    item.isEditing = true
                    state.ui.errors.hasError = true;
                }
            });
     

            state.selectItems.forEach((item: any) => {
                item.costError = false
                // Do not accept 0 as a valid cost
                if (item.cost === null || item.cost === undefined || item.cost === '' || Number(item.cost) === 0) {
                    item.costError = true
                    item.isEditing = true
                    state.ui.errors.hasError = true;
                }
            });

            state.selectItems.forEach((item: any) => {
                item.nameError = false
                if (!item?.name) {
                    item.nameError = true
                    item.isEditing = true
                    state.ui.errors.hasError = true;
                }
            });

        }

        function usdPriceFormate(data: any) {
            if (data != null) {
                return data.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                });
            }

        }


        function getItemList() {
            state.ui.isLoading.getItemList = true
            state.ui.isLoading.getData = true
            ethitransService
                .getActiveItemList(state.data.searchName)
                .then((res: any) => {
                    state.tableData = [];
                    res.data.data.mainitems.forEach((item: any) => {
                        const childData = [] as any;
                        item.subitems.forEach((subItem: any) => {
                            const subData = {
                                id: subItem.id,
                                name: subItem.name,
                                description: subItem.description,
                                unit: subItem.unit ? subItem.unit.name : '',
                                cost: usdPriceFormate(subItem.cost ? subItem.cost : 0),
                                markup: usdPriceFormate(subItem.markup ? subItem.markup : 0),
                            }
                            childData.push(subData)
                        });
                        const pushData = {
                            id: item.id,
                            name: item.name,
                            description: item.description,
                            unit: item.unit ? item.unit.name : '',
                            cost: usdPriceFormate(item.cost ? item.cost : 0),
                            markup: usdPriceFormate(item.markup ? item.markup : 0),
                            _children: childData,
                        };
                        state.tableData.push(pushData);
                    });
                    res.data.data.mainitems.forEach((item: any) => {
                        item.isChecked = false;
                        item.markup = item.markup ? item.markup : 0;
                        item.cost = item.cost ? item.cost : 0;
                        item.subTotal = item.cost ? item.cost : 0;
                        item.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === item.unit_id)[0];
                        if (item.markup_type == 1) {
                            const parCal = (parseFloat(item.cost) * parseFloat(item.markup)) / 100;
                            item.total = parCal + parseFloat(item.cost);
                        } else {
                            item.total = parseFloat(item.cost) + parseFloat(item.markup);
                        }
                        item.subitems.forEach((subItem: any) => {
                            subItem.isChecked = false;
                            subItem.mainName = item.name;
                            subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                            if (subItem.markup_type == 1) {
                                const parCal = (parseFloat(subItem.cost) * parseFloat(subItem.markup)) / 100;
                                subItem.total = parCal + parseFloat(subItem.cost);
                            } else {
                                subItem.total = parseFloat(subItem.cost) + parseFloat(subItem.markup);
                            }
                            subItem.subTotal = subItem.cost ? subItem.cost : 0;
                        });
                    });
                    state.data.lineItems = res.data.data.mainitems;

                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getItemList = false;
                    state.ui.isLoading.getData = false;
                });
        }

        function checkSubItem(item: any) {
            if (item.subitems) {
                item.subitems.forEach((subItem: any) => {
                    subItem.isChecked = item.isChecked;
                });
            }
        }
        function checkItem(item: any) {
            if (item.subitems) {
                const allChecked = item.subitems.every((subItem: any) => subItem.isChecked);
                item.isChecked = allChecked;
                state.ui.isPostLoading.selectedButton = true;
            }
        }

        function checkInputNumber(item: any) {
            const data = item.toString().replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            return data;
        }



        const iconFormatter = (cell: any) => {

            const rows = tabulator.value.getRows();
            for (let i = 0; i < rows.length; i++) {
                const children = rows[i].getTreeChildren();
                for (let j = 0; j < children.length; j++) {
                    const child = children[j].getData();
                    if (state.selectedRows.includes(child['id'])) {
                        children[j].select();
                    }
                }
            }
            tabulator.value.selectRow(state.selectedRows);
            const row = cell.getRow();
            return row.getTreeParent() ? '' : `<i class="fa fa-plus"></i> ${t('add')}`;


        };
        function addSubItem(data: any) {
            state.selectItemId = '';
            state.selectItemId = data;
            state.dataFor = 'subItem';
            state.ui.isLoading.addNewSubItem = !state.ui.isLoading.addNewSubItem;
            $(`.job-item-dropdown${state.selectIndex}`).dropdown('toggle');
            $(`.job-item-dropdown${state.selectIndex}`).dropdown('hide');
            state.selectIndex = '';
        }
        function resizeTable() {
            if (state.selectItems.length > 0) {
                tabulator.value = new Tabulator(table.value, {

                    height: "311px",
                    layout: "fitColumns",
                    dataTree: true,
                    dataTreeStartExpanded: true,
                    dataTreeFilter: true, //disable child row filtering
                    // getData: true,
                    paginationSize: 10000,
                    ajaxURL: `${config.apiBaseUrl}all/item`,
                    progressiveLoad: "scroll",
                    placeholder: "No Data Set",
                    ajaxProgressiveLoad: true,
                    ajaxProgressiveLoadScroll: 10000,
                    progressiveLoadDelay: 500,
                    progressiveLoadScrollMargin: 500,
                    ajaxConfig: {
                        method: "GET", //set request type to Position
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("current_user_token")}`,
                        },
                    },
                    // 👇 Add this function to customize request params
                    ajaxRequestFunc: function (url: any, config: any, params: any) {
                        params["per_page"] = params.size;
                        delete params.size;

                        // ✅ Add external search param
                        if (itemSearchedvalue.value) {
                            params["search"] = itemSearchedvalue.value;
                        }

                        const query = new URLSearchParams(params).toString();
                        return fetch(`${url}?${query}`, config).then(response => response.json());
                    },
                    columns: [
                        // titleFormatter: "rowSelection",
                        {
                            formatter: "rowSelection", hozAlign: "center", width: 100, headerSort: false, cellClick: function (e: any, cell: any) {
                                cell.getRow().toggleSelect();
                            }
                        },
                        { title: t('name'), field: "name", sorter: "string", width: 200, headerFilter: "input", headerFilterPlaceholder: t('find_a_item') },
                        { title: t('description'), field: "description", width: 300, sorter: "string" },
                        { title: t('unit'), field: "unit", sorter: "string" },
                        { title: t('cost'), field: "cost", sorter: "string" },
                        { title: t('markup'), field: "markup", sorter: "string" },
                        {
                            title: t('action'), field: "naiconme", hozAlign: "center", formatter: iconFormatter, cellClick: function (e: any, cell: any) {
                                const row = cell.getRow();
                                const parentId = row.getData().uuid;
                                addSubItem(parentId);
                                showItemModal.value = false
                            },
                            tooltip: function (e: any, cell: any, onRendered: any) {
                                //e - mouseover event
                                //cell - cell component
                                //onRendered - onRendered callback registration function

                                const el = document.createElement("div");
                                el.style.backgroundColor = "white";
                                el.innerText = t('add_a_new_sub_item')

                                return el;
                            },
                        }], //define table columns
                    
                });

            }

        }


        function closeSelected(index: any) {
            state.ui.isLoading.getData = true;

            // Get all selected IDs from Tabulator
            const selectedData = tabulator.value.getSelectedData();
            const selectedIds = selectedData.map((item: any) => item.id);
            console.log('selected ids', selectedIds);

            // Step 1: Reset all checks
            state.selectedRows = [];

            state.data.lineItems.forEach((lineItem: any) => {
                lineItem.isChecked = false;
                lineItem.isEditing = true
                if (lineItem.subitems) {
                    lineItem.subitems.forEach((subItem: any) => {
                        subItem.isChecked = false;
                        subItem.isEditing = true;
                    });
                }
            });

            // Only set isNew = true for new items, leave existing as is
            selectedData.forEach((selected: any) => {
                state.data.lineItems.forEach((lineItem: any) => {
                    if (lineItem.id === selected.id) {
                        lineItem.isChecked = true;
                        // Only set isNew if not already in selectItems
                        const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === lineItem.id);
                        if (!alreadyExists) {
                            lineItem.isNew = true;
                        }
                        state.selectedRows.push(lineItem.id);
                    }
                    lineItem.subitems.forEach((subItem: any) => {
                        if (subItem.id === selected.id) {
                            subItem.isChecked = true;
                            const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === subItem.id);
                            if (!alreadyExists) {
                                subItem.isNew = true;
                            }
                            state.selectedRows.push(subItem.id);
                        }
                    });
                });
            });

            // // --- Track deleted items ---
            // // Find items that were previously in selectItems but are no longer selected, and are not new or copy
            // const prevSelectedMainItemIds = state.selectItems
            //     .filter((item: any) => item.id !== undefined && item.id !== 0)
            //     .map((item: any) => item.id);

            // const removedItemIds = prevSelectedMainItemIds.filter((id: any) => !selectedIds.includes(id));
            // // Only add to deletedItemsIds if not already present
            // removedItemIds.forEach((id:any) => {
            //     // Find the item in selectItems to check if it's not new/copy
            //     const removedItem = state.selectItems.find((item: any) => item.main_item_id === id);
            //     if (
            //         removedItem &&
            //         !removedItem.isNew &&
            //         !removedItem.isCopy &&
            //         !deletedItemsIds.value.includes(id)
            //     ) {
            //         deletedItemsIds.value.push(id);
            //     }
            // });

            // Step 3: Remove unchecked items from selectItems
            state.selectItems = state.selectItems.filter((item: any) =>
                selectedIds.includes(item.main_item_id) || Object.keys(item).length === 0 || item.id === 0
            );

            // Step 4: Add newly checked items (only add new, don't update existing)
            state.data.lineItems.forEach((lineItem: any) => {

                lineItem.mainName = '';
                const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === lineItem.id);
                const emptyIndex = state.selectItems.findIndex((item: any) => Object.keys(item).length === 0 || item.id == 0);
                if (emptyIndex !== -1) {
                    state.selectItems.splice(emptyIndex, 1);
                }
                console.log('already', alreadyExists)
                if (lineItem.isChecked && !alreadyExists && lineItem.id != 0) {
                    lineItem.quantity = 1;
                    state.selectItems.push(lineItem);
                }

                lineItem.subitems.forEach((subItem: any) => {
                    subItem.mainName = lineItem.name;
                    const alreadyExists = state.selectItems.some((item: any) => item.main_item_id === subItem.id);
                    const emptyIndex = state.selectItems.findIndex((item: any) => Object.keys(item).length === 0 || item.id == 0);
                    if (emptyIndex !== -1) {
                        state.selectItems.splice(emptyIndex, 1);
                    }

                    if (subItem.isChecked && !alreadyExists && subItem.id != 0) {
                        subItem.quantity = 1;
                        state.selectItems.push(subItem);
                    }
                });
            });

            // Step 6: If nothing selected, show default
            if (state.selectItems.length === 0) {
                state.selectItems = [{
                    id: 0,
                    total: 0,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    markup_type: defMarkUpType.value,
                    isEditing: true
                }];
            }

            state.ui.isLoading.getData = false;
            console.log(state.selectItems)

            // Step 7: Close dropdown
            showItemModal.value = false
            itemSearchedvalue.value = ''
        }


         function onToggleChooseItem(index: any) {
            state.selectIndex = '';
            state.selectIndex = index;
            state.ui.isLoading.getData = true;
            state.selectItems[index].tableSelected = true;
            setTimeout(() => {
                state.ui.isLoading.getData = false;
                resizeTable();
            }, 500)
            showItemModal.value = true;
        }

        // function cloneItem(index: any, item: any) {

        //     state.cloningSelectedItem = true;

        //     const newItem = cloneDeep(state.selectItems);

        //     const originalItem = cloneDeep(newItem[index]);
        //     originalItem.isCopy = true;
        //     originalItem.isEditing = true; // Set isEditing to true for the cloned item

        //     const updatedItems = newItem
        //         .slice(0, index + 1)
        //         .concat(originalItem)
        //         .concat(newItem.slice(index + 1));

        //     // eslint-disable-next-line @typescript-eslint/camelcase
        //     state.selectItems = [];
        //     setTimeout(() => {
        //         state.selectItems = updatedItems;
        //         state.cloningSelectedItem = false;
        //     }, 0);

        // }
       function cloneItem(index: any, item: any) {
            state.cloningSelectedItem = true;

            const newItem = cloneDeep(state.selectItems);
            const originalItem = cloneDeep(newItem[index]);
            originalItem.isCopy = true;
            originalItem.isEditing = true;

            const updatedItems = newItem
                .slice(0, index + 1)
                .concat(originalItem)
                .concat(newItem.slice(index + 1));

            state.selectItems = [];

            setTimeout(() => {
            state.selectItems = updatedItems;
            state.cloningSelectedItem = false;

            requestAnimationFrame(() => {
                const clonedRow = document.querySelectorAll("tbody tr")[index + 1]; 
                // index+1 because clone is inserted after original
                if (clonedRow) {
                    clonedRow.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                });
            }, 0);
        }



        function getAllUnits() {

            state.ui.isLoading.getUnit = true
            state.ui.isLoading.getData = true;
            ethitransService
                .getUnitList()
                .then((res: any) => {
                    state.data.unitLists = res.data.data;

                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getUnit = false;
                    state.ui.isLoading.getData = false;
                });

        }



        function removeSelectedSubItem(item: any) {
            // Ensure deletedItems array exists in state
            if (!deletedItemsIds.value) {
                deletedItemsIds.value = [];
            }
            // Add the item to the deletedItems array
            if (item.main_item_id) {
                deletedItemsIds.value.push(item.id as never);
            }

            if(item.main_item_id){
                state.selectedRows = state.selectedRows.filter((id: any) => id !== item.main_item_id);
            }else{
                state.selectedRows = state.selectedRows.filter((id: any) => id !== item.id);
            }

            item.isChecked = false;
            const selectedIndex = common.findIndex(state.selectItems, item);
            if (selectedIndex !== -1) {
                state.selectItems[selectedIndex].isChecked = false;
            }
            state.selectItems = state.selectItems.filter((e: any) => e != item);
            state.selectDeleteItem = '';
            deleteItemClose();
        }


        function calculateTotal(item: any) {
            const selectedIndex = common.findIndex(state.selectItems, item);
            state.selectItems[selectedIndex].cost = checkInputNumber(item.cost ? item.cost : 0);
            state.selectItems[selectedIndex].markup = checkInputNumber(item.markup ? item.markup : 0);
            const total = computed(() => {
                if (item.markup_type == 1) {
                    const prCal = ((state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0) * (state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0) * (state.selectItems[selectedIndex].markup ? parseFloat(state.selectItems[selectedIndex].markup) : 0)) / 100;
                    return prCal + ((state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0) * (state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0));
                } else {

                    return ((state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0) * (state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0)) + (state.selectItems[selectedIndex].markup ? parseFloat(state.selectItems[selectedIndex].markup) : 0);
                }

            });
            state.selectItems[selectedIndex].total = total;
            state.selectItems[selectedIndex].subTotal = ((state.selectItems[selectedIndex].quantity ? parseFloat(state.selectItems[selectedIndex].quantity) : 0) * (state.selectItems[selectedIndex].cost ? parseFloat(state.selectItems[selectedIndex].cost) : 0));

            if (item.isAllowance) {
                state.selectItems[selectedIndex].allowance = state.selectItems[selectedIndex].subTotal;
            }

        }

        function copyTotalAmount(item: any) {
            const selectedIndex = common.findIndex(state.selectItems, item);
            state.selectItems[selectedIndex].allowance = state.selectItems[selectedIndex].subTotal;
            console.log('abc', state.selectItems[selectedIndex].allowance);
        }

        function addUnitShow() {
            $("#addUnite").modal("show");
        }
        function addUniteClose() {
            state.ui.errors.validationErrorList.unitName = "";
            state.ui.errors.validationErrorList.unitAbbreviation = "";
            state.data.unit.abbreviation = "";
            state.data.unit.name = "";
            $("#addUnite").modal("hide");
            state.ui.isLoading.isUnitEdit = false;
        }

        function changeMarkupType(index: any, value: any) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            state.selectItems[index].markup_type = value;

            calculateTotal(state.selectItems[index]);
        }

        function changeUnit(index: any, value: any) {
            console.log(index, value);
            // eslint-disable-next-line @typescript-eslint/camelcase
            state.selectItems[index].unit_id = value.id;
            state.selectItems[index].unit = value;
        }

        function editUnit(item: any) {
            state.data.unit.name = item.name;
            state.data.unit.abbreviation = item.abbreviation;
            state.selectUnitId = item.id;
            state.ui.isLoading.isUnitEdit = true;
            addUnitShow();
        }

        function addNewUnit(item: any) {
            state.selectSubItemIndex = '';
            state.selectSubItemIndex = common.findIndex(state.selectItems, item);
            addUnitShow();
        }

        function deleteUnitList(item: any, unitList: any) {
            state.selectSubItemIndex = '';
            state.selectSubItemIndex = common.findIndex(state.selectItems, item);
            ethitransService
                .deleteUnite(unitList.id)
                .then((res: any) => {
                    if (state.selectItems[state.selectSubItemIndex].selectUnit) {
                        state.selectItems[state.selectSubItemIndex].selectUnit = '';
                    }
                    state.data.unitLists = res.data.data;


                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // state.ui.isLoading.getUnit = false;
                });

        }

        function updateMarkupType(item: any) {
            const payLoad = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                markup_type: item,
            };
            ethitransService
                .updateMarkupType(payLoad)
                .then((res: any) => {
                    defMarkUpType.value = res.data.data.markup_type;

                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    // state.ui.isLoading.getUnit = false;
                });

        }

        function deleteUnit(item: any, unitList: any) {
            const result = window.confirm('Do you want to delete?');
            if (result) {
                deleteUnitList(item, unitList);
                console.log('User clicked "Yes"');
            } else {

                console.log('User clicked "No"');
            }
        }


        function createUnitValidation() {
            state.ui.errors.validationErrorList.unitName = "";
            if (!state.data.unit.name) {
                state.ui.errors.validationErrorList.unitName = "Ener valid unit";
                state.ui.errors.hasError = true;
            }
            // if (!state.data.unit.abbreviation) {
            //     state.ui.errors.validationErrorList.unitAbbreviation = "Ener valid abbreviation";
            //     state.ui.errors.hasError = true;
            // }
        }

        function createUnit() {
            state.ui.isPostLoading.addUnite = false;
            state.ui.errors.hasError = false;
            createUnitValidation();
            if (state.ui.isPostLoading.addUnite || state.ui.errors.hasError) return false;
            const payLoad = {

                name: state.data.unit.name,
                abbreviation: state.data.unit.abbreviation,

            };
            state.ui.isPostLoading.addUnite = true;
            ethitransService
                .createUnit(payLoad)
                .then((res: any) => {
                    state.selectItems[state.selectSubItemIndex].unit = res.data.data[0];
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    state.selectItems[state.selectSubItemIndex].unit_id = res.data.data[0].id;

                    state.data.unitLists = res.data.data;
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createUnit)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createUnit.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.addUnite = false;
                    addUniteClose();

                });
        }

        function updateUnit() {
            state.ui.isPostLoading.addUnite = false;
            state.ui.errors.hasError = false;
            createUnitValidation();
            if (state.ui.isPostLoading.addUnite || state.ui.errors.hasError) return false;
            const payLoad = {

                name: state.data.unit.name,
                abbreviation: state.data.unit.abbreviation,

            };
            state.ui.isPostLoading.addUnite = true;
            ethitransService
                .updateUnit(state.selectUnitId, payLoad)
                .then((res: any) => {
                    state.data.unitLists = res.data.data;

                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createUnit)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createUnit.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.addUnite = false;
                    state.selectUnitId = '';
                    addUniteClose();

                });
        }

        const total = computed(() => {

            const total = state.selectItems.reduce((total: any, item: any) => total + item.total, 0);
            return total ? total : 0;

        })


        const totalMarkUP = computed(() => {
            return state.selectItems.reduce((total: any, item: any) => {
                if (item.markup_type == 1) {
                    const tot = total + (parseFloat(item.cost) * parseFloat(item.markup) * parseFloat(item.quantity)) / 100;
                    // return tot ? common.usdPriceFormate(tot) : common.usdPriceFormate(0);
                    return tot ? tot : 0;

                } else {
                    const tot = (total + parseFloat(item.markup));
                    return tot ? tot : 0;
                    // return tot ? common.usdPriceFormate(tot) : common.usdPriceFormate(0);
                }
            }, 0);
        })

        function clearAllJobItem() {
            state.data.lineItems.forEach((item: any) => {
                item.isChecked = false;
                item.subitems.forEach((subItem: any) => {
                    subItem.isChecked = false;
                });
            });
            
            state.selectItems = [{
                'id': 0,
                'markup_type': defMarkUpType,
                'cost': 0,
                'markup': 0,
                'quantity': '',
                'tableSelected': false,
                'isAllowance': false,
                'isEditing': true
            }];
            state.selectedRows = [];
        }



        function creatJobEstimation() {
            state.ui.isPostLoading.createJobEstimation = false;
            state.ui.errors.hasError = false;
            validationCreateJobEstimation();
            if (state.ui.isPostLoading.createJobEstimation || state.ui.errors.hasError) return false;
            const payLoad = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                project_id: state.projectId,
                items: state.selectItems,
                title: state.data.title,

            };
            state.ui.isPostLoading.createJobEstimation = true;
            ethitransService
                .createJobEstimation(payLoad)
                .then((res: any) => {
                    console.log(res);
                    state.estimationUUId = res.data.data.uuid;
                    state.data.successFulMessage = t('create_job_estimation_successfully');
                    state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createJobEstimation)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createJobEstimation.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.createJobEstimation = false;
                    // hasUnsavedChanges.value = false;
                    markAsSaved();

                });
        }

        function addNewSubItem(index: any) {
            state.selectItemId = '';
            state.ui.isLoading.addNewSubItem = !state.ui.isLoading.addNewSubItem
            $(`.job-item-dropdown${index}`).dropdown('toggle');
            $(`.job-item-dropdown${index}`).dropdown('hide');

            // $('.job-item-dropdown').dropdown('toggle');
            // $('.job-item-dropdown').dropdown('hide')
        }

        function saveItem() {
            state.ui.isLoading.addNewSubItem = !state.ui.isLoading.addNewSubItem
            getItemList();
            getAllUnits();
        }

        function getJobestimationDetail() {
            state.ui.isLoading.getItemList = true
            ethitransService
                .getJobestimationDetail(props.editId)
                .then((res: any) => {
                    state.selectItems = [];
                    state.data.title = res.data.data.title;
                    state.data.createDate = moment(res.data.data.created_date).format("Y-MM-DD");
                    res.data.data.items.forEach((subItem: any) => {
                        subItem.isChecked = true;
                        subItem.isEditing = true;
                        subItem.isAllowance = subItem.is_allowance === 1;
                        subItem.mainName = subItem.main_item_name;
                        subItem.subTotal = parseFloat(subItem.cost) * parseFloat(subItem.quantity);
                        subItem.selectUnit = state.data.unitLists.filter((unit: any) => unit.id === subItem.unit_id)[0];
                        if (subItem.markup_type == 1) {
                            const parCal = ((parseFloat(subItem.cost) * parseFloat(subItem.quantity)) * parseFloat(subItem.markup)) / 100;
                            subItem.total = parCal + (parseFloat(subItem.cost) * parseFloat(subItem.quantity));
                        } else {
                            subItem.total = (parseFloat(subItem.cost) * parseFloat(subItem.quantity)) + parseFloat(subItem.markup);
                        }
                    });
                    state.selectItems = res.data.data.items;
                    console.log('The state selectitems>>>', res.data.data)
                    state.selectedRows = state.selectItems.map((item: any) => item.main_item_id);
                })
                .catch((error: any) => {
                    console.log(error);
                })
                .finally(() => {
                    state.ui.isLoading.getItemList = false;
                });
        }

        function updateJobEstimation() {
            state.ui.isPostLoading.createJobEstimation = false;
            state.ui.errors.hasError = false;
            validationCreateJobEstimation();
            if (state.ui.isPostLoading.createJobEstimation || state.ui.errors.hasError) return false;
            const newItem = [] as any;
            const oldItem = [] as any;
            state.selectItems.forEach((item: any) => {
                if (item.isNew || item.isCopy) {
                    newItem.push(item);
                } else {
                    oldItem.push(item);
                }
            });
            const payLoad = {
                // eslint-disable-next-line @typescript-eslint/camelcase
                project_id: state.projectId,
                // eslint-disable-next-line @typescript-eslint/camelcase
                estimation_id: props.editId,
                title: state.data.title,
                items: oldItem,
                // eslint-disable-next-line @typescript-eslint/camelcase
                new_item: newItem,
                "deleted_item_ids": deletedItemsIds.value

            };
            state.ui.isPostLoading.createJobEstimation = true;
            ethitransService
                .updateJobEstimation(payLoad)
                .then((res: any) => {
                    state.estimationUUId = res.data.data.uuid;
                    state.data.successFulMessage = "Update Job Estimation Successfully.";
                    state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
                    deletedItemsIds.value = [];
                })
                .catch((error: any) => {
                    common
                        .sdCatchErr(error, state.ui.errors.errorList.createJobEstimation)
                        .then((res: any) => {
                            state.ui.errors.hasError = true;
                            for (const [key, value] of Object.entries(res)) {
                                if (Array.isArray(value)) {
                                    state.ui.errors.errorList.createJobEstimation.push(value[0]);
                                }
                            }
                        });
                })
                .finally(() => {
                    state.ui.isPostLoading.createJobEstimation = false;
                    hasUnsavedChanges.value = false

                });
        }

        function saveSend() {
            if (state.ui.isLoading.isEdit) {
                state.ui.isLoading.isSaveSend = true;
                updateJobEstimation();
            } else {
                state.ui.isLoading.isSaveSend = true;
                creatJobEstimation();
            }

        }

        onBeforeRouteLeave((to, from) => {
            addUniteClose()
            deleteItemClose()
            $("#SuccessfulModalCustom").modal("hide");
        })

        function startRecording(index: any, newValue: any) {
            state.selectItems[index].description = state.selectItems[index].description + ' ' + newValue;
        }
        function updateItem(index: any, newValue: any) {

            state.selectItems[index].cost = newValue.replace(/[$,]/g, '')
        }

        function updateItemMarkup(index: any, newValue: any) {
            state.selectItems[index].markup = newValue.replace(/[$,]/g, '');
        }

        function updateItemAllowance(index: any, newValue: any) {
            state.selectItems[index].allowance = newValue.replace(/[$,]/g, '');
        }

        function gotoCreateLineItem() {
            router.push({
                name: "list-line-item",
            });
        }

        const formatCurrency = (value: any) => {
            if (value && typeof value === 'string') {
                const numericValue = parseFloat(value.replace(/[^\d.]/g, '')) || 0;
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                return formatter.format(numericValue);
            } else {
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                return formatter.format(value);
            }
            // Format as currency using Intl.NumberFormat



        };
        const formatPrice = (index: any) => {
            // Update the price format when the input changes
            state.selectItems[index].cost = formatCurrency(state.selectItems[index].cost);
        };



        const applyFilter = () => {
            if (state.data.searchName === '') {
                // If filter is empty, reset to original data
                tabulator.value.setData(state.tableData);
            } else {
                const currentData = tabulator.value.getData();
                const filteredData = currentData.filter((row: any) =>
                    Object.values(row).some((value) =>
                        String(value).toLowerCase().includes(state.data.searchName.toLowerCase())
                    )
                );
                tabulator.value.setData(filteredData);
            }
        };

        // // When user types in external input
        // function applyFilter(event: Event) {
        //     const input = event.target as HTMLInputElement;
        //     itemSearchedvalue.value = input.value;

        //     if (tabulator.value) {
        //         tabulator.value.setData(`${config.apiBaseUrl}all/item`);
        //     }
        // }


        function userStatus() {

            const payLoad = {
                email: localStorage.getItem("current_user_email"),
            };
            ethitransService
                .userStatus(payLoad)
                .then((res: any) => {
                    defMarkUpType.value = res.data.data.markup_type;
                })
                .catch((error: any) => {
                    //
                })
                .finally(() => {
                    //   state.ui.isLoading.userStatus = true;
                });
        }

        function showAddDetails(index: any) {
            $("#addDetails" + index).modal("show");
        }
        const columns = ref([
            { label: 'Item' },
            { label: 'Description' },
            { label: 'Qty' },
            { label: 'Unit' },
            { label: 'Cost' },
            { label: 'Sub Total' },
            { label: 'Markup' },
            { label: 'Set Allowance' },
            { label: 'Allowance' },
            { label: 'Total' },
            { label: 'Action' },
        ]);

        // const columnWidths = ref([180, 200, 60, 110, 100, 120, 100, 80, 80, 100, 140]); // Column widths

        const defaultColumnWidths = [180, 250, 70, 120, 80, 130, 140, 70, 130, 140, 120];
        const columnWidths = ref([...defaultColumnWidths]);
        const totalTableWidth = computed(() => columnWidths.value.reduce((a: any, b: any) => a + b, 0));

        const computedColumnWidth = (index: any) => {
            return `${columnWidths.value[index]}px`;
        };


        function adjustActionColumnWidth() {

            const actionColumnCells = document.querySelectorAll('td:nth-child(11)');
            let maxWidth = 0;
            actionColumnCells.forEach((cell: any) => {
                const cellWidth = cell.offsetWidth;
                if (cellWidth > maxWidth) {
                    maxWidth = cellWidth;
                }
            });
            const adjustedWidth = maxWidth + 20;
            columnWidths.value[10] = adjustedWidth;
        }

        function addMoreSubItems(item: any) {
            state.ui.isLoading.getData = true;
            if (Object.keys(item).length != 0) {
                // eslint-disable-next-line @typescript-eslint/camelcase
                state.selectItems.push(JSON.parse(JSON.stringify({ id: 0, total: 0, markup: 0, cost: 0, markup_type: defMarkUpType.value, tableSelected: false, isAllowance: false, isEditing:true })));
            }
            adjustActionColumnWidth();

            const tableContainer = document.querySelector('.custom-table-responsive');
            if (tableContainer) {
                tableContainer.scrollLeft = 0;
            }

            state.ui.isLoading.getData = false;
        }


        let startX = 0;
        let startWidth = 0;
        let currentColumnIndex = -1;

        const resizeColumn = (event: any) => {
            console.log('Hello this is resize')
            const currentX = event.clientX || event.touches[0].clientX;
            const newWidth = startWidth + (currentX - startX);
            // if (newWidth >= defaultColumnWidths[currentColumnIndex]) {
            if (newWidth > defaultColumnWidths[currentColumnIndex]) { // Ensure min column width
                columnWidths.value[currentColumnIndex] = newWidth;
            }
        };

        const stopResize = () => {
            document.removeEventListener("mousemove", resizeColumn);
            document.removeEventListener("mouseup", stopResize);
            document.removeEventListener("touchmove", resizeColumn);
            document.removeEventListener("touchend", stopResize);
        };

        const startResize = (index: any, event: any) => {
            currentColumnIndex = index;
            startX = event.clientX || event.touches[0].clientX;
            startWidth = columnWidths.value[index];

            if (event.type === "mousedown") {
                document.addEventListener("mousemove", resizeColumn);
                document.addEventListener("mouseup", stopResize);
            } else if (event.type === "touchstart") {
                document.addEventListener("touchmove", resizeColumn);
                document.addEventListener("touchend", stopResize);
            }
        };
        onBeforeUnmount(() => {
            document.removeEventListener('mousemove', resizeColumn);
            document.removeEventListener('mouseup', stopResize);
            document.removeEventListener('touchmove', resizeColumn);
            document.removeEventListener('touchend', stopResize);
        });

        function adjustInputWidth(event: any) {
            const input = event.target;
            input.style.width = `${input.value.length * 10 + 20}px`; // Adjust size dynamically
        }


        onMounted(() => {
            userStatus();
            getItemList();
            getAllUnits();
            const url: any = window.location.href;
            const page: any = url.split("#/").pop().split("/")[0];
            if (props.editId) {
                state.ui.isLoading.isEdit = true
                getJobestimationDetail();
            }
            resizeTable();
        });
        // Method to handle checkbox change
        const handleCheckboxChange = (item: any, index: any, event: any) => {
            console.log("HELLO >>> ", item);
            console.log("INDEX >>> ", index);
            console.log("EVEN CHECK  >>> ", event);
            // Set the isChecked property based on the checkbox state
            item.isAllowance = event.target.checked;

            // If checked, set the Allowance to subTotal
            if (item.isAllowance) {
                state.selectItems[index].allowance = item.subTotal;
                state.selectItems[index].isAllowance = event.target.checked;
            } else {
                // Optionally, reset Allowance if unchecked (you can define your own behavior here)
                state.selectItems[index].allowance = 0;
                state.selectItems[index].isAllowance = event.target.checked;
            }
        };


        const editRow = (index: number) => {
            const user = state.selectItems[index];    
            user.isEditing = true;
        };

        const saveRow = (index: number) => {
            const user = state.selectItems[index]; 
            if (user) {
                user.isEditing = false;
            }
        };

        onBeforeUnmount(() => {
            const dropdown = $('.dropdown-wrap');
            if (dropdown.length > 0) {
                try {
                    dropdown.dropdown('hide');
                    console.log('Dropdown hidden before unmount');
                } catch (e) {
                    console.warn('Dropdown hide failed:', e);
                }
            }
        });

        return {
            state,
            columns,
            columnWidths,
            totalTableWidth,
            startResize,
            adjustActionColumnWidth,
            handleCheckboxChange,
            // updateAllowance,
            getItemList,
            checkSubItem,
            checkItem,
            closeSelected,
            removeSelectedSubItem,
            addMoreSubItems,
            checkInputNumber,
            calculateTotal,
            addUnitShow,
            addUniteClose,
            changeMarkupType,
            changeUnit,
            addNewUnit,
            editUnit,
            deleteUnitList,
            deleteUnit,
            createUnit,
            updateUnit,
            total,
            totalMarkUP,
            clearAllJobItem,
            creatJobEstimation,
            gotoJobEstimation,
            closeSuccessCustomModal,
            addNewSubItem,
            saveItem,
            validationCreateJobEstimation,
            getJobestimationDetail,
            updateJobEstimation,
            saveSend,
            gotoJobEstimationSend,
            deleteItemClose,
            deleteItemShow,
            updateItem,
            updateItemMarkup,
            updateItemAllowance,
            usdPriceFormate,
            cloneItem,
            formatPrice,
            formatCurrency,
            tabulator,
            table,
            resizeTable,
            applyFilter,
            filterValue,
            onToggleChooseItem,
            iconFormatter,
            addSubItem,
            gotoCreateLineItem,
            updateMarkupType,
            userStatus,
            defMarkUpType,
            copyTotalAmount,
            showAddDetails,
            startRecording,
            isEditMode,
            adjustInputWidth,
            computedColumnWidth,
            // markAsDirty,
            hasUnsavedChanges,
            originalState,
            handleBeforeUnload,
            editRow,
            saveRow,
            showItemModal,
            currenylySelectedState,
            itemSearchedvalue,
            deletedItemsIds
        };
    },
});
